export default __webpack_public_path__ + "static/media/Office02.8b9b16c7.jpg";